'use strict';
var globalThis = require('../internals/global-this');

module.exports = globalThis;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/internals/path.js
// module id = 27
// module chunks = 0